import { render, staticRenderFns } from "./IndexTableBulkActions.vue?vue&type=template&id=1bb03534&scoped=true"
import script from "./IndexTableBulkActions.vue?vue&type=script&lang=js"
export * from "./IndexTableBulkActions.vue?vue&type=script&lang=js"
import style0 from "./IndexTableBulkActions.vue?vue&type=style&index=0&id=1bb03534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb03534",
  null
  
)

export default component.exports